// src/pages/History/19thcentury/IndustrialRevolution.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/19th_Century_-_Industrial_Revolution.png';

function HistoryPageIndustrialRevolution() {
  return (
    <TopicPage
      topicKey="Industrial Revolution"
      title="History: Industrial Revolution"
      backgroundImage={bg}
      startRoute="/History-Industrial-Revolution-Go"
      scrollLabels={[
        "Factories and Mechanization",
        "Urbanization and Labor",
        "Technological Inventions",
      ]}
      backRoute="/history-19th-century"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageIndustrialRevolution;
